import {Component, OnInit} from '@angular/core';
import {ToastService} from '../../services/toast.service';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ToastMessageModel} from '../../models/toast-message-model';
import {ToastTypeEnum} from '../../enums/toast-type';

@UntilDestroy()
@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('hideAnimation', [
            state('visible', style({opacity: 1})),
            state('hidden', style({opacity: 0})),
            transition('visible => hidden', [animate('300ms ease-out')]),
        ]),
    ],
})
export class ToastComponent implements OnInit {
    toast: ToastMessageModel | null = null;
    animationState: 'visible' | 'hidden' = 'visible';
    private closeTimeout: number; // is used

    constructor(private toastService: ToastService) {
    }

    ngOnInit(): void {
        this.toastService.toast$.pipe(untilDestroyed(this)).subscribe((toastToDisplay: ToastMessageModel) => {
            this.toast = toastToDisplay;
            if (this.toast) {
                this.animationState = 'visible';
                this.closeTimeout = null;
            } else {
                this.animationState = 'hidden';
            }

        });
    }

    onCloseBtnClick() {
        this.close();
    }

    onBackdropClick() {
        this.close();
    }

    close() {
        this.animationState = 'hidden'; // start fade-out animation
        this.closeTimeout = setTimeout(() => {
            this.toastService.closeToast(); // close after while to allow animation to be partially visible
        }, 150);
    }

    getClass(type: ToastTypeEnum) {
        switch (type) {
            case ToastTypeEnum.SUCCESS:
                return 'success';
            case ToastTypeEnum.ERROR:
                return 'error';
            case ToastTypeEnum.WARNING:
                return 'warning';
            case ToastTypeEnum.INFO:
                return 'info';
            default:
                console.warn(`Unknown toast type: ${type}`);
                return 'info';
        }

    }


}
